import React from 'react';
import PropTypes from 'prop-types';
import 'react-confirm-alert/src/react-confirm-alert.css';
import FocusTrap from 'focus-trap-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';

export class Modal extends React.Component {

    render() {
        const { onClose, header, children, className, describedBy } = this.props;
        return (
          <FocusTrap>
                <div
                    id="dialog-modal"
                    className={className}
                    aria-modal
                    role="dialog"
                    aria-labelledby="dialog-modal__title"
                    aria-describedby={describedBy}
                >
                    <div className="alert-heading">
                        <div className="grid-row flex-align-center flex-justify">
                            <div id="dialog-modal__title">{header}</div>
                            <div>
                                {onClose && (
                                    <button
                                        id="version-history-close"
                                        className="usa-button usa-button--unstyled close-button float-right padding-x-0"
                                        onClick={onClose}
                                        title="Close Modal"
                                        aria-label="Close Modal"
                                    >
                                        <FontAwesomeIcon icon={faTimesCircle} size="2x" className="margin-right-1" />
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                    {children}
                </div>
          </FocusTrap>
        );
    }
}

Modal.propTypes = {
    header: PropTypes.string.isRequired,
    onClose: PropTypes.func,
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
    className: PropTypes.string,
    describedBy: PropTypes.string
};

export default Modal;



// WEBPACK FOOTER //
// ./src/features/common/Modal.js